


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BillingAddress } from '@/interfaces/BillingAddress';

@Component({
    name: 'BillingAddressesSelect',
})
export default class BillingAddressesSelect extends Vue {

    @Prop({required: true}) public billingAddresses!: BillingAddress[];

    private activeBillingAddressId: number | null = null;
    private activeBillingAddress: BillingAddress | null = null;

    protected onBillingAddressChange() {
        const billingAddress = this.billingAddresses.find(
            (billingAddressItem: BillingAddress) => this.activeBillingAddressId === billingAddressItem.id);
        if (!billingAddress) {
            this.activeBillingAddress = null;
            return;
        }
        this.activeBillingAddress = billingAddress;
        this.$emit('change', this.activeBillingAddress);
    }

    @Watch('billingAddresses', {immediate: true})
    protected onBillingAddressesChange() {
        if (!this.billingAddresses.length) {
            return;
        }
        this.activeBillingAddressId = this.billingAddresses[0].id;
        this.onBillingAddressChange();
    }

}
